<template>
    <div>
        <div class="row pxo-3 mbo-3">
            <div class="col-6 text-uppercase">
                Depositing Ends in
            </div>
            <div class="col-6 text-right font-weight-bold">
                <count-down
                    :expiry="vaultExpiry"
                    id="expiry"
                    :key="Math.random()"
                />
            </div>
        </div>
        <div class="row pxo-3 mbo-3">
            <div class="col-6 text-uppercase">
                Available Balance
            </div>
            <div class="col-6 text-right font-weight-bold">
                <span style="text-transform:uppercase;">
                    {{ wallet.balance }}
                    {{ vault.real_token_symbol }}
                </span>
            </div>
        </div>
        <div>
            <div class="input-group input-group-outline mbo-3 flex-nowrap">
                <input
                    type="number"
                    class="form-control mto-1"
                    :placeholder="`0 ${vault.real_token_symbol.toUpperCase()}`"
                    aria-label="Deposits"
                    aria-describedby="basic-addon2"
                    :disabled="!approved || depositing"
                    v-model="depositInput"
                    id="deposit-input"
                    @keypress="isNumber($event)"
                />
                <div class="input-group-append text-center">
                    <a
                        id="deposit-max"
                        :class="!approved || depositing ? 'disabled' : ''"
                        @click="maxDeposit"
                        class="text-green-gradient max-button-style"
                        href="#"
                        >MAX</a
                    >
                </div>
            </div>
        </div>

        <div class="row mbo-3 pxo-3">
            <!--mb-n4 -->
            <template v-if="approved">
                <template v-if="!depositing">
                    <div
                        v-if="hasQueuedWithdrawls"
                        style="display: flex;justify-content: center;width: 100%;padding-bottom: 1em;"
                    >
                        Can't deposit while withdrawals are pending
                    </div>
                    <div class="col-12 d-flex p-0">
                        <button
                            @click="depositToVault"
                            class="btn btn-primary btn-vault-strip"
                            type="button"
                            :disabled="depositDisabled"
                            id="deposit-more"
                            style="width:100%"
                        >
                            deposit
                        </button>
                    </div>
                </template>
                <div
                    v-else
                    style="display: flex;align-items: center;margin-left: 2em;width: 100%;justify-content: center; height:20px;"
                >
                    <div class="text-green-gradient" id="waiting-for-reply">
                        Waiting for reply
                    </div>
                    <div>&nbsp;</div>
                    <div
                        style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                    >
                        <div class="dot-falling"></div>
                    </div>
                </div>
            </template>

            <div v-else class="col-12 p-0">
                <div v-if="!hasWallet" style="text-align:center">
                    Connect Metamask / Wallet Connect
                </div>
                <template v-else>
                    <template v-if="!hasToken">
                        <div
                            v-if="checkingToken"
                            style="display:flex;flex-direction: row;justify-content: center;align-items: center; height:20px"
                        >
                            <div
                                class="text-green-gradient"
                                id="checking-token-approval"
                            >
                                Checking
                                {{ vault.token }} approval
                            </div>
                            <div>&nbsp;</div>
                            <div
                                style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                            >
                                <div class="dot-falling"></div>
                            </div>
                        </div>
                        <button
                            v-else
                            class="btn btn-primary  btn-vault-strip"
                            style="width:100%;"
                            @click="addToken()"
                            id="add-to-wallet"
                        >
                            Add {{ vault.token }} to wallet
                        </button>
                    </template>

                    <template v-else>
                        <div
                            v-if="checkingApproval"
                            style="display:flex;flex-direction: row;justify-content: center;align-items: center; height:20px"
                        >
                            <div
                                class="text-green-gradient"
                                id="checking-asset-approval"
                            >
                                Checking asset approval
                            </div>
                            <div>&nbsp;</div>
                            <div
                                style="display: flex;min-width:4em;justify-content: center;align-items: center;position: relative;padding: 2rem 0;overflow: hidden;"
                            >
                                <div class="dot-falling"></div>
                            </div>
                        </div>
                        <button
                            v-else
                            class="btn btn-primary btn-vault-strip"
                            style="width:100% !important;"
                            @click="approve"
                            id="approve-vault-allowance"
                        >
                            Approve vault allowance
                        </button>
                    </template>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
    data() {
        return {
            depositInput: 0
        };
    },
    computed: {
        ...mapState("il", [
            "vault",
            "tab",
            "contract",
            "checkingToken",
            "hasToken",
            "checkingApproval",
            "approved",
            "depositing",
            "vaultAtMaxBalance",
            "requesting",
            "withdrawing",
            "ableToInitWIthdraw",
            "hasQueuedWithdrawls"
        ]),
        ...mapState(["wallet"]),
        ...mapGetters({
            hasWallet: "wallet/getHasWallet"
        }),
        depositDisabled() {
            return (
                this.vaultAtMaxBalance ||
                this.depositInput === "" ||
                this.depositInput <= 0 ||
                +this.depositInput > +this.wallet.balance ||
                (this.vault.userInfo.queuedWithdraw > 0 &&
                    this.vault.userInfo.exitQueueEpoch > 0)
            );
        },
        vaultExpiry(){
            return new Date(this.vault.expiry*1000).toISOString();
        }
    },
    watch: {
        "$store.state.wallet.balance": {
            handler: function(nval) {
                this.setData({ key: "checkingToken", value: false });
                this.setData({ key: "hasToken", value: true });
            }
        },
        depositInput(v,o){
            const splitValue = v.split('.');
            const token = this.wallet.tokens.find(item => item.symbol == this.vault.real_token_symbol && item.network == this.vault.network);

            const decimalPlaces = (splitValue[1]).length; // count decimal places
            if(decimalPlaces > token.decimals.toString().length - 1) this.depositInput = o // compare inputed amount decimal with token decimal
        }
    },
    methods: {
        ...mapActions("il", ["setData", "checkAllowance"]),
        async addToken() {
            this.setData({ key: "checkingToken", value: true });

            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.vault.real_token_symbol &&
                    item.network == this.vault.network
            );
            //
            if (token == undefined) return;
            let res = await this.$store.dispatch("wallet/addToken", {
                vault_contract: this.vault.contract_address,
                token: token
            });

            if (res) {
                this.setData({ key: "hasToken", value: true });
                this.setData({ key: "checkingToken", value: false });

                this.checkAllowance();
            } else {
                this.setData({ key: "hasToken", value: false });
                this.setData({ key: "checkingToken", value: false });
            }
        },
        maxDeposit() {
            this.depositInput = this.wallet.balance;
        },
        async depositToVault() {
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.vault.real_token_symbol &&
                    item.network == this.vault.network
            );
            if (token == undefined) return;

            this.setData({ key: "depositing", value: true });

            let payload = {
                amount: this.depositInput,
                vault_contract: this.vault.contract_address,
                abiType: this.vault.type,
                maxDeposit: this.vault.max_deposit, //this value is overwritten by the max deposit value from the vault contract via getVaultInfo() instead of db
                token: token
            };

            try {
                deposit = await this.$store.dispatch("vaults/deposit", payload);
            } catch (error) {
                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    deposit = await this.$store.dispatch(
                        "vaults/deposit",
                        payload
                    );
                }
            }

            // this.$emit("update-vault");

            this.setData({ key: "depositing", value: false });
            this.depositInput = "";
        },
        async approve() {
            let token = this.wallet.tokens.find(
                item =>
                    item.symbol == this.vault.real_token_symbol &&
                    item.network == this.vault.network
            );
            //
            if (token == undefined || !this.wallet.walletProvider) return;

            this.setData({ key: "checkingApproval", value: true });

            let res;
            let payload = {
                vault_contract: this.vault.contract_address,
                token: token
            };

            try {
                res = await this.$store.dispatch("vaults/approve", payload);
            } catch (error) {
                if (error.code && error.code === -32602) {
                    // send request in non EIP-1559 format
                    payload.type = "0x0";
                    res = await this.$store.dispatch("vaults/approve", payload);
                }
            }

            if (!res) {
                this.setData({ key: "checkingApproval", value: false });
                return;
            }

            if (res.status) {
                this.$nextTick(() => {
                    this.setData({ key: "hasToken", value: true });
                    this.setData({ key: "approved", value: true });
                    this.setData({ key: "checkingApproval", value: false });
                });
            }
        }
    }
};
</script>
